import React from "react";
import meOne from "../../imgs/my-photo/me.webp";
import { projectData } from "../../data/Projects";
import { expData } from "../../data/Experiences";

function Home() {
  const stats = [
    { value: `${String(projectData.length).padStart(2, "0")}`, label: "Projects" },
    { value: `${String(expData.length).padStart(2, "0")}`, label: "Positions" },
    { value: "2026", label: "Available" },
  ];

  return (
    <section
      id='home'
      className='w-full border-b border-line bg-background pt-28 md:pt-32'
    >
      <div className='swiss-container'>
        <div className='grid grid-cols-1 gap-y-12 lg:grid-cols-12 lg:gap-x-10'>
          {/* Headline block */}
          <div className='flex flex-col justify-between py-12 lg:col-span-8 lg:pb-20 lg:pt-6'>
            <div>
              <span className='font-body text-xs font-medium uppercase tracking-widest text-primary/50'>
                Full-Stack Developer
              </span>

              <h1 className='mt-8 font-heading text-4xl font-extrabold uppercase leading-[0.92] tracking-tighter text-primary sm:text-5xl md:text-6xl lg:text-7xl'>
                Building
                <br />
                Digital
                <br />
                Systems<span className='text-accent'>.</span>
              </h1>

              <p className='mt-10 max-w-xl font-body text-base leading-relaxed text-primary/60 md:text-lg'>
                I engineer front-to-back products that balance visual identity,
                sound architecture, and real-world usability — from e-commerce
                platforms to finance tools.
              </p>
            </div>

            {/* Actions */}
            <div className='mt-12 flex flex-wrap items-stretch gap-3'>
              <a
                href='#contact'
                className='flex items-center bg-primary px-8 py-4 font-body text-xs font-semibold uppercase tracking-wider text-background transition-colors hover:bg-accent hover:text-white'
              >
                Get in touch
              </a>
              <a
                href='#project'
                className='flex items-center border border-primary/25 px-8 py-4 font-body text-xs font-semibold uppercase tracking-wider text-primary transition-colors hover:border-primary'
              >
                View projects
              </a>
            </div>
          </div>

          {/* Portrait — flat, grid-cropped */}
          <div className='lg:col-span-4 lg:border-l lg:border-line lg:pl-10'>
            <div className='mx-auto flex h-full w-full max-w-[280px] flex-col py-0 sm:max-w-xs lg:mx-0 lg:max-w-none lg:pb-20 lg:pt-6'>
              <div className='relative aspect-[4/5] w-full overflow-hidden border border-line bg-secondary'>
                <img
                  src={meOne}
                  alt='Zin Myo Win'
                  className='h-full w-full object-cover grayscale'
                />
              </div>
              <div className='flex items-baseline justify-between border-x border-b border-line px-4 py-3'>
                <span className='font-body text-xs font-bold uppercase tracking-wider text-primary'>
                  Zin Myo Win
                </span>
                <span className='font-body text-2xs uppercase tracking-widest text-primary/40'>
                  Fig. 01
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Stats row aligned to grid */}
        <div className='grid grid-cols-3 border-t border-line'>
          {stats.map((item, idx) => (
            <div
              key={item.label}
              className={`py-6 ${idx !== 0 ? "border-l border-line pl-5" : ""}`}
            >
              <p className='font-heading text-3xl font-bold tabular-nums text-primary md:text-4xl'>
                {item.value}
              </p>
              <p className='mt-2 font-body text-2xs font-medium uppercase tracking-widest text-primary/45'>
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Home;
